import { render, staticRenderFns } from "./OutboxSendPackage.vue?vue&type=template&id=a6db736e&scoped=true"
import script from "./OutboxSendPackage.vue?vue&type=script&lang=js"
export * from "./OutboxSendPackage.vue?vue&type=script&lang=js"
import style0 from "./OutboxSendPackage.vue?vue&type=style&index=0&id=a6db736e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6db736e",
  null
  
)

export default component.exports